import { AdvancedVehicleFeatureType } from '../../services/endpoints/GetDetails';

export const ADASFeatures: AdvancedVehicleFeatureType[] = [
  {
    featureGroup: 'Parking Assistance',
    featureDataName: 'parkingAssistance',
    subCategories: [
      'Rear Parking Sensor',
      'Front Camera',
      'Rear Camera',
      '360 Degree Camera',
      'Front Parking Sensor',
      'Read Cross-Traffic Warning',
    ],
    toolTipText:
      'These features help drivers while parking their vehicle, using cameras, sensors, or warnings.',
  },
  {
    featureGroup: 'Driving Assistance',
    featureDataName: 'drivingAssistance',
    subCategories: [
      'Forward Collision Warning',
      'Pedestrian Warning',
      'Lane Departure Warning',
      'Driver Attention Alert',
      'Blind Spot Warning',
    ],
    toolTipText: 'These features alert drivers to hazards on the road.',
  },
  {
    featureGroup: 'Active Assistance',
    featureDataName: 'activeAssistance',
    subCategories: [
      'Forward Collision Mitigation',
      'Rollover Mitigation',
      'Adaptive Cruise Control',
      'Lane Departure Prevention',
      'Pedestrian Protection',
      'City Collision Mitigation',
      'Blind Spot Intervention',
      'Rear Cross Traffic Alert',
      'Automatic Parking Assistance',
    ],
    toolTipText:
      "These features may override the driver's action to prevent accidents and danger while a vehicle is in motion.",
  },
];
